import { Card, Col, Table } from "react-bootstrap";
import useCallApi from "../../../hooks/useCallApi";
import Loading from "../../../templates/UI/Loading/Loading";
import moment from "moment";
import Dollars from "../../../templates/Dollars/Dollars";
import useDateRangeFilter from "../../../hooks/useDateRangeFilter";
import DateRangeFilter from "../../../pages/Reports/Filters/DateRangeFilter/DateRangeFilter"
import React, { useContext } from "react";
import ReportTable from "../../../templates/ReportTable/ReportTable";
import Advertiser from "../../../templates/Advertiser/Advertiser";
import useQueryParams from "../../../hooks/useQueryParams";
import AdvertiserNavbar from "../AdvertiserNavBar/AdvertiserNavBar";
import { SystemMessageContext } from '../../../context/SystemMessageContext';


const PaidInvoiceReport = ({ advertiserId }) => {

    const { selectedStartDate, selectedEndDate, quickDate, handleChangeStart, handleChangeEnd, handleQuickDate } = useDateRangeFilter()
    const { navigation } = useQueryParams()
    const { showSystemMessage } = useContext(SystemMessageContext)
    const { data, dataLoaded, refetch } = useCallApi(`advertiser/${advertiserId || 0}/paidInvoicesReport?startDate=${selectedStartDate}&endDate=${selectedEndDate}`, 'GET', {}, [advertiserId]);


    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Advertiser Name',
                accessor: 'merchant_id',
                Cell: ({ cell: { value }, row: { original } }) => {
                    return <Advertiser id={value} name={original.merchant_name} />
                },
            },
            {
                Header: 'Invoice Number',
                accessor: 'invoice_num',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: <div style={{ textAlign: 'right' }}>Received Amount</div>,
                accessor: 'amount',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
        ]

        return (
            <React.Fragment>
                <ReportTable data={data.data} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Paid Invoice Report</h1>
                {navigation === 'advertiser' && (
                    <div className="ml-5">
                        <AdvertiserNavbar advertiserId={advertiserId} showSystemMessage={showSystemMessage} />
                    </div>
                )}
            </div>
            <div className="col-lg-6">
                {dataLoaded ? (
                    data.success ?
                        <Card>
                            <Card.Header className="d-flex p-3 align-items-center">                                
                                <DateRangeFilter quickDate={quickDate} selectedStartDate={selectedStartDate} selectedEndDate={selectedEndDate} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} handleQuickDate={handleQuickDate} />
                                <button onClick={refetch} className="btn btn-sm btn-primary">
                                    Refresh Report
                                </button>
                            </Card.Header>
                            {getReportOutput()}
                        </Card>
                        :
                        (<p>No paid invoices found.</p>)
                ) : (
                    <Loading />
                )}
            </div>
        </>
    );
}

export default PaidInvoiceReport;